export default {
  emptyNotice: 'Pas de contenu temporairement',
}
